import { RequestParam } from '../../../domain/models/RequestParam';
import { Sku } from '../../../domain/models/Sku';
import { SkuDetail, SkuDetailSection } from '../../../domain/models/SkuDetail';

export enum ModalStep {
    SELECT_SKU,
    SKU_SALE,
    CONFIRM,
    SKU_PROCESSING_PAYMENT,
    SKU_RESULT
}

export interface SaleStateInterface {
    modalShow: boolean;
    step: number;
    setup: ModalSaleSetup;
    loader: SaleLoaderState;
    sku?: Sku;
    skuDetail?: SkuDetail;
    elementsInBody: SkuDetailSection[];
    params: Array<RequestParam>;
    modalStep: ModalStep;
    result?: SkuDetail;
    pdfFailed: boolean;
    // [Balance Step 1]: Configuracion de saleStateInterface
    clientBalance: {};
    loadingBalance: boolean;

}

export class SaleState implements SaleStateInterface {
    modalShow: boolean;
    step: number;
    setup: ModalSaleSetup;
    loader: SaleLoaderState;
    sku?: Sku;
    skuDetail?: SkuDetail | undefined;
    elementsInBody: SkuDetailSection[];
    params: RequestParam[];
    modalStep: ModalStep;
    result?: SkuDetail;
    pdfFailed: boolean;
    clientBalance: ClientBalanceInfo;
    loadingBalance: boolean;

    constructor({
        modalShow = false,
        step = 0,
        setup = new ModalSaleSetup(),
        loader = new SaleLoaderState({}),
        sku = undefined,
        skuDetail = undefined,
        elementsInBody = [],
        params = [],
        modalStep = ModalStep.SELECT_SKU,
        result = undefined,
        pdfFailed = false,
        clientBalance = new ClientBalanceInfo(),
        loadingBalance = true,

    }: SaleStateInterface
    ) {
        this.modalShow = modalShow;
        this.step = step;
        this.setup = setup;
        this.loader = loader;
        this.sku = sku;
        this.params = params;
        this.elementsInBody = elementsInBody;
        this.skuDetail = skuDetail;
        this.modalStep = modalStep;
        this.result = result;
        this.pdfFailed = pdfFailed;
        this.clientBalance = new ClientBalanceInfo();
        this.loadingBalance = loadingBalance;
    }
}

export class ModalSaleSetup {
    title: string;
    sku?: Sku;
    options: Sku[];
    constructor({
        title = undefined,
        sku = undefined,
        options = undefined
    }: any = {}) {
        this.title = title;
        this.sku = sku;
        this.options = options;
    }
}

export class SaleLoaderState {
    isLoading: boolean = false;
    message: string;
    constructor({
        isLoading = false,
        message = ""
    }: any = {}) {
        this.isLoading = isLoading;
        this.message = message;
    }
}


// [Balance Step 2] Modelo de datos que representa el componente de saldo del cliente recibido desde backend y usado en el estado global

export class ClientBalanceInfo {
  id: number = -1;
  stage: number = 0;
  ordinal: number = 0;
  param: string | null = null;
  send_to_server: string | null = null;
  read_from_server: boolean = false;
  modal_section: string = '';
  web_component: string = '';
  web_label: string | null = null;
  web_value: string | null = null;
  engine_exec: string | null = null;
  constraints: any = null;

  constructor(data?: Partial<ClientBalanceInfo>) {
    if (data) {
      Object.assign(this, data);
    }
  }
}
